import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import { LabelConfiguration, LabelTemplate, PrintLabelAttrs, adjustConfigToUserDefinedDimensions, labelEditorSlice, labelTemplates, newPrintLabel, printLabelSelector } from 'cdx-common';
import { useSelector } from 'react-redux';
import { RootState, appStore } from 'store';
import { useSession } from '../../libraries/SessionProvider';
import { LabelTemplateRenderer, PrintLabelRenderer } from './labels/LabelRenderer';
import { NewPrintLabelOptions } from './labels/NewPrintLabelOptions';


export const NewPrintLabel = () => {

    const paper: Set<string> = new Set(labelTemplates.map(p => p.paper.name));
    const printLabels: PrintLabelAttrs[] = useSelector((state: RootState) => printLabelSelector.selectAll(state));
    const { user } = useSession();
    const selectedPrintLabel = useSelector((state: RootState) => state.labelEditor.selectedPrintLabel);
    const selectedPrintLabelModel = useSelector((state: RootState) => selectedPrintLabel?.printLabelId ? printLabelSelector.selectById(state, selectedPrintLabel.printLabelId) : undefined);

    const onTemplateSelected = (template: LabelTemplate) => {
        // create a new printjob using current template
        let baseConfig: LabelConfiguration = {
            columnMapping: {},
            orhanLabelsAtEndJob: false,
            sameColumnGrouping: [],
            labelClassName: template.paper.labelClassName,
            labelCountHorizontally: template.labelCountHorizontally ?? template.paper.labelCountHorizontally ?? 1,
            labelCountVertically: template.labelCountVertically ?? template.paper.labelCountVertically ?? 1,
            labelWidth: '',
            labelHeight: '',
        };
        appStore.dispatch(labelEditorSlice.actions.setCurrentPrintLabel({
            ...newPrintLabel,
            authorId: user?.id ?? '0',
            items: [],
            template: { ...template },
            configuration: template.userDefinedDimensions !== undefined ? adjustConfigToUserDefinedDimensions(template.userDefinedDimensions, baseConfig, template) : {
                ...baseConfig,
                labelWidth: (template.labelWidth ?? (((1 / (template.labelCountHorizontally ?? 1)) * 100).toFixed(2) + '%')),
                labelHeight: (template.labelHeight ?? (((1 / (template.labelCountHorizontally ?? 1)) * 100).toFixed(2) + '%'))
            },
            createdAt: '',
            updatedAt: '',
            deletedAt: null
        }));

    };


    const onPrintLabelSelected = (printLabel: PrintLabelAttrs) => {
        appStore.dispatch(labelEditorSlice.actions.setCurrentPrintLabel({ ...printLabel }));
    };

    return <><Typography variant='h4'>Nouvelle étiquette</Typography>

        {Array.from(paper.values()).map((paperName, paperIndex) => {
            return <div key={'paper' + paperIndex}>
                <Typography key={paperIndex} variant='h2'>{paperName}</Typography>
                <Stack direction='row'>
                    {labelTemplates.filter(q => q.paper.name === paperName).map((q) => {
                        return <Paper key={'template' + q.name}><Typography variant='body1'>{q.name} (Vide)</Typography>
                            <Box sx={{ border: 'solid 1px #DDD' }}>
                                {selectedPrintLabel?.paperName == q.name && selectedPrintLabelModel ?
                                    <PrintLabelRenderer infos={{
                                        configuration: selectedPrintLabelModel.configuration,
                                        items: selectedPrintLabelModel.items,
                                        template: selectedPrintLabelModel.template
                                    }} /> :
                                    <LabelTemplateRenderer infos={{ template: q }} />}
                            </Box>
                            <NewPrintLabelOptions
                                paperName={q.name}
                                printLabels={printLabels.filter(r => r.template.name === q.name)}
                                onEmptyClick={() => onTemplateSelected(q)} />

                            <Box sx={{ m: 1, justifyContent: 'center' }}>

                                <Button color='primary' variant='contained' onClick={() => {
                                    if (selectedPrintLabel?.paperName == q.name && selectedPrintLabelModel) {
                                        onPrintLabelSelected(selectedPrintLabelModel);
                                    } else {
                                        onTemplateSelected(q);
                                    }
                                }}>Sélectionner</Button>
                            </Box>
                        </Paper>;
                    })}

                </Stack>
            </div>;
        })}
    </>;
};
